import { deburr } from 'lodash';

const SearchService = {
  removeAccent(searchValue: string): string {
    return deburr(searchValue);
  },
};

export default SearchService;
